import * as React from "react";
import { SELECT_CALLBACK_FIELD_PHONE } from "Constants/metriks/Yandex";
import Metrika from "Services/Metrika";
export const CallbackBase = ComposedComponent =>
    class extends React.Component {
        constructor(props) {
            super(props);
            this.state = { isSend: false };
        }

        onSend(data) {
            this.setState({
                isSend: true,
            });
        }

        onFocusPhoneHandler() {}

        render() {
            return (
                <ComposedComponent
                    {...this.props}
                    onSend={data => this.onSend(data)}
                    onFocusPhone={() => this.onFocusPhoneHandler()}
                    isSend={this.state.isSend}
                />
            );
        }
    };
